import BenchlingConfig from 'BenchlingConfig';

/**
 * Whether MCP / AI Connectors UI should be available.
 */
export function isMcpAiConnectorsFeatureEnabled(): boolean {
  return (
    // Both Deep Research (Ask) and Assistant use MCP; gate on either feature flag.
    (BenchlingConfig.LLM_ENABLE_AI_DEEP_RESEARCH || BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT) &&
    // On private deploys, we allow tenant admins to manage MCP servers.
    // On non-private deploys (benchling.com), because there are no tenant admins to add custom MCP servers,
    // MCP is only available if the Extension Directory is enabled from which to install Benchling-curated MCP servers.
    (BenchlingConfig.PRIVATE_DEPLOY || BenchlingConfig.ENABLE_EXTENSION_DIRECTORY)
  );
}
